import React, { useRef, useEffect } from 'react';
import MessageList from '../Chat/MessageList';

const MainChat = ({
  messages,
  isLoading,
  onSendMessage,
  projectData,
  currentSceneIndex,
  setCurrentSceneIndex,
  sceneGenerationStatus,
  isGeneratingScene,
  onGenerateScene,
  onApproveScene,
  onRefineScene,
  onFinalizeProject,
  onCreateProject,
  onNewChat,
  resetKey,  
}) => {
  const messagesEndRef = useRef(null);

   const prevLengthRef = useRef(0);
  
 useEffect(() => {
    const newLength = messages.length;
    if (newLength > prevLengthRef.current) {
     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
   }
   prevLengthRef.current = newLength;
 }, [messages]);

  return (
    <div className="w-full h-screen flex flex-col bg-gray-50">
      <div className="flex-1 overflow-y-auto px-4 py-4 min-h-0">
        <MessageList
          messages={messages}
          isLoading={isLoading}
          projectData={projectData}
          currentSceneIndex={currentSceneIndex}
          setCurrentSceneIndex={setCurrentSceneIndex}
          sceneGenerationStatus={sceneGenerationStatus}
          isGeneratingScene={isGeneratingScene}
          onGenerateScene={onGenerateScene}
          onApproveScene={onApproveScene}
          onRefineScene={onRefineScene}
          onFinalizeProject={onFinalizeProject}
          onCreateProject={onCreateProject}
          onNewChat={onNewChat}
          onSendMessage={onSendMessage}
          resetKey={resetKey}
        />
        <div ref={messagesEndRef} />
      </div>
      {/* No bottom InputArea — VideoGeneratorLayout owns the submit button in all states */}
    </div>
  );
};

export default MainChat;
